import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useLang } from "../contexts/LanguageContext";
import { Wordmark } from "./Logo";
import { Menu, X } from "lucide-react";

export const Navbar = () => {
  const { t, lang, toggle } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  const links = [
    { to: "/", label: t.nav.home },
    { to: "/hakkimizda", label: t.nav.about },
    { to: "/hizmetler", label: t.nav.services },
    { to: "/ekip", label: t.nav.team },
    { to: "/iletisim", label: t.nav.contact },
  ];

  return (
    <header
      data-testid="public-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white border-b border-[#0F2746]/10 shadow-sm"
          : "bg-white border-b border-[#0F2746]/5"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-32 lg:h-36 flex items-center justify-between">
        <Link to="/" data-testid="navbar-logo-link" aria-label="Alaca Partners">
          <Wordmark />
        </Link>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.to.replace("/", "") || "home"}`}
              className={({ isActive }) =>
                `text-[13px] tracking-wide ap-link-underline transition-colors ${
                  isActive ? "text-[#0F2746]" : "text-[#3A5170] hover:text-[#0F2746]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <button
            data-testid="lang-toggle-btn"
            onClick={toggle}
            className="overline text-[10px] text-[#0F2746] border border-[#0F2746]/30 hover:border-[#0F2746] hover:bg-[#0F2746] hover:text-[#F3F5F8] transition-all px-3 py-2"
          >
            {lang === "tr" ? "EN" : "TR"}
          </button>
          <button
            data-testid="mobile-menu-btn"
            onClick={() => setOpen((o) => !o)}
            className="lg:hidden p-2 text-[#0F2746]"
            aria-label="menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#F6F8FA] border-t border-[#0F2746]/10">
          <nav className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`mobile-nav-link-${l.to.replace("/", "") || "home"}`}
                className={({ isActive }) =>
                  `font-serif-ap text-2xl ${isActive ? "text-[#0F2746]" : "text-[#3A5170]"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};
